import { errorMsg } from '../constants/messages';

const seoFormData = [
  {
    name: 'id',
    label: 'ID',
    fieldType: {
      name: 'none',
    },
    tableMeta: { title: 'ID', enableSort: true },
    isTableHeader: true,
    isAccordian: false,
    errorMsg: errorMsg,
    default: '',
  },
  {
    title: 'SEO Details',
    name: 'pageUrl',
    label: 'Page URL',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Page URL', enableSort: true, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'metaTitle',
    label: 'Meta Title',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Meta Title', enableSort: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'metaDescription',
    label: 'Meta Description',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description', enableSort: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'keywords',
    label: 'Keywords',
    fieldType: {
      name: 'textarea',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Keywords', enableSort: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'tags',
    label: 'Tags',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Tags', enableSort: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'createdAt',
    label: 'Created At',
    fieldType: {
      name: 'none',
    },
    tableMeta: { title: 'Created At', enableSort: true },
    isTableHeader: true,
    isAccordian: false,
    errorMsg: errorMsg,
    default: '',
  },
];

export { seoFormData };
